import IaConfigForm from './IaConfigForm';

export default IaConfigForm;
export * from './IaConfigForm';
